export default __webpack_public_path__ + "static/media/wave.cb380fee.png";